var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "search-results-new-d__category-path" },
    [
      _c("a", {
        staticClass:
          "js-suggest-item search-results-new-d__category-path-title",
        attrs: { href: _vm.link },
        domProps: {
          innerHTML: _vm._s(
            _vm.getSearchCaption(_vm.title, _vm.query.trim().toLowerCase())
          )
        },
        on: {
          click: function($event) {
            return _vm.$emit("clickHandler", _vm.title)
          }
        }
      }),
      _vm._v(" "),
      _vm._l(_vm.breadcrumbs, function(item) {
        return _c("a", {
          key: item.name,
          staticClass: "search-results-new-d__category-path-item",
          attrs: { href: item.url },
          domProps: {
            innerHTML: _vm._s(
              _vm.getSearchCaption(item.name, _vm.query.trim().toLowerCase())
            )
          },
          on: {
            click: function($event) {
              return _vm.$emit("clickHandler", item.name)
            }
          }
        })
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }